export default class SignatureModal {
    
    constructor() {
        this.isVisible = false;
        this.signatureData = null;
        this.drawingMode = false;
        this.createModal();
        this.bindEvents();
    }

    createModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'stc-signature-modal';
        
        this.modal.innerHTML = `
            <div class="stc-signature-modal-content">
                <div class="stc-signature-modal-header">
                    <h3>Customize Your Signature</h3>
                    <button class="stc-signature-modal-close">&times;</button>
                </div>
                <div class="stc-signature-modal-body">
                    <div class="stc-signature-tabs">
                        <button class="stc-signature-tab active" data-tab="text">Text Signature</button>
                        <button class="stc-signature-tab" data-tab="draw">Draw Signature</button>
                    </div>
                    
                    <div class="stc-signature-panels">
                        <div class="stc-signature-panel active" id="stc-signature-text">
                            <div class="stc-signature-form">
                                <div class="stc-signature-input-group">
                                    <label for="signature-text">Signature Text</label>
                                    <input type="text" id="signature-text" class="stc-signature-text-input" placeholder="Enter your name">
                                </div>
                                
                                <div class="stc-signature-input-group">
                                    <label for="signature-font">Signature Font</label>
                                        <select id="signature-font" class="stc-signature-font-select">
                                            <option value="'STC_Mistral', normal">Mistral</option>
                                            <option value="'STC_ArialMS', normal">Arial MS</option>
                                            <option value="'STC_Birthstone', normal">Birthstone</option>
                                            <option value="'STC_Rage', normal">Rage</option>
                                            <option value="'STC_Ballet', normal">Ballet</option>
                                        </select>
                                </div>
                            </div>
                            
                            <div class="stc-signature-preview">
                                <div class="stc-signature-preview-text">Preview</div>
                                <div class="stc-signature-preview-container" id="text-signature-preview"></div>
                            </div>
                        </div>
                        
                        <div class="stc-signature-panel" id="stc-signature-draw">
                            <div class="stc-signature-draw-controls">
                                <button class="stc-signature-clear-btn">Clear</button>
                                <div class="stc-signature-line-width">
                                    <label for="line-width">Line Width</label>
                                    <input type="range" id="line-width" min="1" max="10" value="3">
                                </div>
                                <div class="stc-signature-color">
                                    <label for="line-color">Ink Color</label>
                                    <input type="color" id="line-color" value="#000000">
                                </div>
                            </div>
                            
                            <div class="stc-signature-canvas-container">
                                <canvas id="signature-canvas"></canvas>
                                <div class="stc-signature-canvas-hint">Sign here</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="stc-signature-modal-footer">
                    <button class="stc-signature-cancel-btn">Cancel</button>
                    <button class="stc-signature-apply-btn">Apply Signature</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(this.modal);
        
        // Initialize drawing canvas
        this.initializeCanvas();
        this.updateTextPreview();
    }
    
    initializeCanvas() {
        this.canvas = document.getElementById('signature-canvas');
        
        // Set physical canvas dimensions
        const containerWidth = this.canvas.parentElement.clientWidth;
        const containerHeight = this.canvas.parentElement.clientHeight || 200; // Fallback height
        
        // Get device pixel ratio
        const dpr = window.devicePixelRatio || 1;
        
        // Set the canvas size to match the container size physically
        this.canvas.width = containerWidth * dpr;
        this.canvas.height = containerHeight * dpr;
        
        // Scale canvas using CSS to match container size
        this.canvas.style.width = `${containerWidth}px`;
        this.canvas.style.height = `${containerHeight}px`;
        
        // Get 2D context with alpha enabled for transparency
        this.ctx = this.canvas.getContext('2d', { alpha: true });
        
        // Scale all drawing operations by the device pixel ratio
        this.ctx.scale(dpr, dpr);
        
        // Store the DPR for calculations
        this.dpr = dpr;
        
        this.isDrawing = false;
        
        // Set up drawing properties for smoother lines
        this.ctx.lineJoin = 'round';
        this.ctx.lineCap = 'round';
        this.ctx.lineWidth = 3;
        this.ctx.strokeStyle = '#000000';
        
        // Add subtle shadow for better appearance
        this.ctx.shadowBlur = 1;
        this.ctx.shadowColor = '#000000';
        
        // Store points for smoothing
        this.points = [];
        this.lastX = 0;
        this.lastY = 0;
    }
    
    updateTextPreview() {
        const text = document.getElementById('signature-text').value || 'Your Signature';
        const font = document.getElementById('signature-font').value;
        // const size = document.getElementById('signature-size').value;
        const preview = document.getElementById('text-signature-preview');
        
        preview.innerHTML = '';
        preview.style.fontFamily = font;
        preview.style.fontSize = `40px`;
        preview.textContent = text;
    }
    
    bindEvents() {
        // Modal close button
        this.modal.querySelector('.stc-signature-modal-close').addEventListener('click', () => {
            this.hide();
        });
        
        // Tab switching
        this.modal.querySelectorAll('.stc-signature-tab').forEach(tab => {
            tab.addEventListener('click', () => {
                // Update active tab
                this.modal.querySelectorAll('.stc-signature-tab').forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                
                // Show selected panel
                const tabId = tab.dataset.tab;
                this.modal.querySelectorAll('.stc-signature-panel').forEach(panel => {
                    panel.classList.remove('active');
                });
                document.getElementById(`stc-signature-${tabId}`).classList.add('active');
                
                // Set drawing mode
                this.drawingMode = tabId === 'draw';
                
                // If switching to drawing tab, reinitialize canvas
                if (this.drawingMode) {
                    this.initializeCanvas();
                }
            });
        });
        
        // Text signature inputs
        const textInput = document.getElementById('signature-text');
        const fontSelect = document.getElementById('signature-font');
        // const sizeSlider = document.getElementById('signature-size');
        
        [textInput, fontSelect].forEach(input => {
            input.addEventListener('input', () => this.updateTextPreview());
        });
        
        // Drawing canvas events
        this.canvas.addEventListener('mousedown', (e) => this.startDrawing(e));
        this.canvas.addEventListener('mousemove', (e) => this.draw(e));
        this.canvas.addEventListener('mouseup', () => this.stopDrawing());
        this.canvas.addEventListener('mouseout', () => this.stopDrawing());
        
        // Touch events for mobile
        this.canvas.addEventListener('touchstart', (e) => {
            e.preventDefault();
            this.startDrawing(this.getTouchPos(e));
        });
        this.canvas.addEventListener('touchmove', (e) => {
            e.preventDefault();
            this.draw(this.getTouchPos(e));
        });
        this.canvas.addEventListener('touchend', () => this.stopDrawing());
        
        // Clear drawing button
        this.modal.querySelector('.stc-signature-clear-btn').addEventListener('click', () => {
            this.clearCanvas();
        });
        
        // Line width control
        document.getElementById('line-width').addEventListener('input', (e) => {
            this.ctx.lineWidth = e.target.value;
        });
        
        // Line color control (added new)
        const colorPicker = document.getElementById('line-color');
        if (colorPicker) {
            colorPicker.addEventListener('input', (e) => {
                this.ctx.strokeStyle = e.target.value;
                this.ctx.shadowColor = e.target.value;
            });
        }
        
        // Button actions
        this.modal.querySelector('.stc-signature-cancel-btn').addEventListener('click', () => {
            this.hide();
        });
        
        this.modal.querySelector('.stc-signature-apply-btn').addEventListener('click', () => {
            this.saveSignature();
            this.hide();
        });
        
        // Handle window resize
        window.addEventListener('resize', () => {
            // Debounce resize event to avoid performance issues
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            
            this.resizeTimeout = setTimeout(() => {
                // Only reinitialize if drawing tab is active
                if (this.drawingMode) {
                    // Save the current drawing
                    const currentDrawing = this.canvas.toDataURL();
                    
                    // Reinitialize canvas with new dimensions
                    this.initializeCanvas();
                    
                    // Restore the drawing if it exists
                    if (currentDrawing && currentDrawing !== 'data:,') {
                        const img = new Image();
                        img.onload = () => {
                            this.ctx.drawImage(img, 0, 0, 
                                this.canvas.width / this.dpr, 
                                this.canvas.height / this.dpr);
                        };
                        img.src = currentDrawing;
                    }
                }
            }, 250);
        });
    }
    
    startDrawing(e) {
        this.isDrawing = true;
        const pos = this.getMousePos(e);
        
        // Store the starting point
        this.lastX = pos.x;
        this.lastY = pos.y;
        this.points = [{x: pos.x, y: pos.y}];
        
        // Remove hint when drawing starts
        const hint = this.modal.querySelector('.stc-signature-canvas-hint');
        if (hint) hint.style.display = 'none';
    }
    
    draw(e) {
        if (!this.isDrawing) return;
        
        const pos = this.getMousePos(e);
        
        // Add point to points array
        this.points.push({x: pos.x, y: pos.y});
        
        // Only keep the last 10 points for efficiency
        if (this.points.length > 10) {
            this.points.shift();
        }
        
        // Clear the canvas area where we'll be drawing
        this.ctx.beginPath();
        
        // If we have at least 3 points, use quadratic curve interpolation
        if (this.points.length >= 3) {
            // Start from the first point
            this.ctx.moveTo(this.points[0].x, this.points[0].y);
            
            // Draw curves through the point array
            for (let i = 1; i < this.points.length - 1; i++) {
                // Calculate control point (midpoint between points)
                const xc = (this.points[i].x + this.points[i+1].x) / 2;
                const yc = (this.points[i].y + this.points[i+1].y) / 2;
                
                // Draw quadratic curve to midpoint using current point as control
                this.ctx.quadraticCurveTo(
                    this.points[i].x, 
                    this.points[i].y, 
                    xc, yc
                );
            }
            
            // Draw a line to the most recent point
            this.ctx.lineTo(
                this.points[this.points.length-1].x, 
                this.points[this.points.length-1].y
            );
        } else {
            // If we only have 2 points, just draw a line
            this.ctx.moveTo(this.lastX, this.lastY);
            this.ctx.lineTo(pos.x, pos.y);
        }
        
        this.ctx.stroke();
        
        // Update last position
        this.lastX = pos.x;
        this.lastY = pos.y;
    }
    
    stopDrawing() {
        this.isDrawing = false;
    }
    
    getMousePos(e) {
        const rect = this.canvas.getBoundingClientRect();
        
        // Calculate position directly in the CSS coordinates
        // (the ctx.scale(dpr, dpr) call in initializeCanvas will convert this to device pixels)
        return {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        };
    }
    
    getTouchPos(e) {
        const rect = this.canvas.getBoundingClientRect();
        const touch = e.touches[0];
        
        // Calculate position directly in the CSS coordinates
        return {
            x: touch.clientX - rect.left,
            y: touch.clientY - rect.top
        };
    }
    
    clearCanvas() {
        // Clear the whole canvas with transparency
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        
        // Show hint again
        const hint = this.modal.querySelector('.stc-signature-canvas-hint');
        if (hint) hint.style.display = 'block';
        
        // Reset points array
        this.points = [];
    }
    
    /**
     * Process the canvas to extract just the signature with transparency
     * Removes empty space around the signature
     */
    processSignatureCanvas() {
        // Create a copy of the canvas to work with
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = this.canvas.width;
        tempCanvas.height = this.canvas.height;
        const tempCtx = tempCanvas.getContext('2d', { alpha: true });
        
        // Copy the original drawing
        tempCtx.drawImage(this.canvas, 0, 0);
        
        // Find the bounds of the signature
        const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
        const { data, width, height } = imageData;
        
        // Initialize bounds
        let minX = width;
        let minY = height;
        let maxX = 0;
        let maxY = 0;
        let foundPixel = false;
        
        // Scan the image data to find the content boundaries
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                // Calculate position in the array - each pixel has 4 values (r,g,b,a)
                const idx = (y * width + x) * 4;
                
                // Check if pixel has any content (non-zero alpha)
                if (data[idx + 3] > 0) {
                    minX = Math.min(x, minX);
                    minY = Math.min(y, minY);
                    maxX = Math.max(x, maxX);
                    maxY = Math.max(y, maxY);
                    foundPixel = true;
                }
            }
        }
        
        // If no pixels are found, return null
        if (!foundPixel) {
            return null;
        }
        
        // Add more generous padding (increased from 20 to 40)
        const padding = 40 * this.dpr;
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(width, maxX + padding);
        maxY = Math.min(height, maxY + padding);
        
        // Calculate the signature dimensions
        const sigWidth = maxX - minX;
        const sigHeight = maxY - minY;
        
        // Create a new canvas with just the signature
        const signatureCanvas = document.createElement('canvas');
        signatureCanvas.width = sigWidth;
        signatureCanvas.height = sigHeight;
        const sigCtx = signatureCanvas.getContext('2d', { alpha: true });
        
        // Draw only the signature portion
        sigCtx.drawImage(
            tempCanvas,
            minX, minY, sigWidth, sigHeight,
            0, 0, sigWidth, sigHeight
        );
        
        return signatureCanvas;
    }
    
    saveSignature() {
        if (this.drawingMode) {
            // Process the signature canvas to get just the signature with transparency
            const signatureCanvas = this.processSignatureCanvas();
            
            // If no signature is found, return
            if (!signatureCanvas) {
                alert('Please draw a signature before applying.');
                return;
            }
            
            // Save drawn signature with transparency preserved
            const dataUrl = signatureCanvas.toDataURL('image/png', 1.0);
            
            this.signatureData = {
                type: 'drawn',
                dataUrl: dataUrl
            };
        } else {
            // Save text signature
            const text = document.getElementById('signature-text').value;
            const font = document.getElementById('signature-font').value;
            // const size = document.getElementById('signature-size').value;
            
            this.signatureData = {
                type: 'text',
                text: text,
                font: font,
                size: 40
            };
        }
        
        this.emit('save', this.signatureData);
    }
    
    show() {
        this.isVisible = true;
        this.modal.classList.add('is-active');
        this.emit('show');
    }
    
    hide() {
        this.isVisible = false;
        this.modal.classList.remove('is-active');
        this.emit('hide');
    }
    
    /**
     * Emit an event
     * 
     * @param {string} eventName - Event name
     * @param {object} detail - Event detail
     */
    emit(eventName, detail = {}) {
        const event = new CustomEvent(`stc:signature:${eventName}`, { detail });
        this.modal.dispatchEvent(event);    
    }

    /**
     * Listen for event
     * 
     * @param {string} eventName - Event name
     * @param {function} callback - Event callback
     */
    on(eventName, callback) {
        this.modal.addEventListener(`stc:signature:${eventName}`, callback);
    }

    /**
     * Remove event listener
     * 
     * @param {string} eventName - Event name
     * @param {function} callback - Event callback
     */
    off(eventName, callback) {
        this.modal.removeEventListener(`stc:signature:${eventName}`, callback);
    }
}